import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/quiz',
    name: 'quiz',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "quiz" */ '../views/QuizView.vue'),
  },
  {
    path: '/planner',
    name: 'planner',
    component: () => import('../views/PlannerView.vue'),
  },
];

const scrollBehavior = (to) => {
  // (to, from, savedPosition../views/ActionDetailsView.vue
  document.getElementById('app').scrollIntoView();

  const headerOffset = 64;

  if (to.hash) {
    return { el: to.hash, top: headerOffset };
  }

  return { x: 0, y: 0 };
};

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior,
});

export default router;
